const isProduction = process.env.NODE_ENV === 'production';

async function cleanupDevelopmentPWA() {
  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map(registration => registration.unregister()));
  }

  if ('caches' in window) {
    const cacheNames = await caches.keys();
    await Promise.all(
      cacheNames
        .filter(name => name.startsWith('tnjtek-member-'))
        .map(name => caches.delete(name))
    );
  }
}

export function registerPWA() {
  if (!('serviceWorker' in navigator)) return;

  if (!isProduction) {
    window.addEventListener('load', () => {
      cleanupDevelopmentPWA().catch(error => {
        console.error('Development PWA cleanup failed:', error);
      });
    });
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${process.env.BASE_URL}service-worker.js`)
      .catch(error => {
        console.error('Service worker registration failed:', error);
      });
  });
}

export async function requestNotificationPermission() {
  if (!('Notification' in window) || !('serviceWorker' in navigator)) {
    return 'unsupported';
  }

  return Notification.requestPermission();
}

function urlBase64ToUint8Array(value) {
  const padding = '='.repeat((4 - (value.length % 4)) % 4);
  const base64 = (value + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');
  const rawData = window.atob(base64);

  return Uint8Array.from(rawData, character => character.charCodeAt(0));
}

export function supportsPushNotification() {
  return isProduction
    && window.isSecureContext
    && 'serviceWorker' in navigator
    && 'PushManager' in window
    && 'Notification' in window;
}

export async function getPushSubscription() {
  if (!supportsPushNotification()) return null;

  const registration = await navigator.serviceWorker.ready;
  return registration.pushManager.getSubscription();
}

export async function subscribePushNotification(publicKey) {
  if (!supportsPushNotification()) {
    throw new Error('Push notification is not supported.');
  }

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') return null;

  const registration = await navigator.serviceWorker.ready;
  const existingSubscription = await registration.pushManager.getSubscription();
  if (existingSubscription) return existingSubscription;

  return registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(publicKey)
  });
}

export async function unsubscribePushNotification() {
  const subscription = await getPushSubscription();
  if (!subscription) return null;

  const endpoint = subscription.endpoint;
  await subscription.unsubscribe();
  return endpoint;
}
